module.exports = __webpack_public_path__ + "img/MUZIK133_air_900x471.8f2077c3.jpg";